import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-ftp-accounts',
  templateUrl: './ftp-accounts.component.html',
  styleUrls: ['./ftp-accounts.component.css']
})
export class FtpAccountsComponent implements OnInit {
    public itemsListFtpAccounts: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadFtpAccounts(): Promise<void> {
        this.itemsListFtpAccounts = await this.datatask.Post(968);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'ftpaccount':
                this.stateService?.go('ftpaccount', { ftpaccount_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadFtpAccounts();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('ftpAccounts', {
//        templateUrl: 'views/components/views/ftpAccounts/ftpAccounts.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ftpAccountsService', function (stateService, ftpAccountsService) {
//            const vm = this;

//            vm.model = {
//                itemsListFtpAccounts: []
//            };

//            async function loadFtpAccounts() {
//                vm.model.itemsListFtpAccounts = (await ftpAccountsService.listFtpAccounts());
//            }

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'ftpaccount':
//                        go({ ftpaccount_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            vm.$onInit = function () {
//                loadFtpAccounts();
//            };
//        }]
//    });
//})();
